export enum BaseStore {
    Hubo = "Hubo_Base_Store",
    Etna = "Etna_Base_Store"
}
